import React from 'react';

function CustomerStatus({ code, title, children }) {
    return (
        <div dir="rtl" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
            <section aria-labelledby="customer-status-title" style={{ width: '100%', maxWidth: '480px', background: '#fff', padding: '40px 24px', borderRadius: '12px', textAlign: 'center' }}>
                <a href="https://akschap.com" style={{ color: '#222', fontSize: '24px' }}>عکسچاپ</a>
                <p style={{ margin: '24px 0 12px', color: '#777' }}>{code}</p>
                <h1 id="customer-status-title" style={{ fontSize: '22px', marginBottom: '16px' }}>{title}</h1>
                <p style={{ lineHeight: '2', marginBottom: '24px' }}>{children}</p>
                <a href="https://akschap.com">رفتن به وب‌سایت عکسچاپ</a>
            </section>
        </div>
    );
}

export function AccessDenied() {
    return (
        <CustomerStatus code="403" title="دسترسی مجاز نیست">
            برای مشاهده سفارش، لطفاً از لینک اختصاصی سفارش خود استفاده کنید.
        </CustomerStatus>
    );
}

export function NotFound() {
    return (
        <CustomerStatus code="404" title="صفحه پیدا نشد">
            آدرس واردشده معتبر نیست. لطفاً لینک سفارش خود را بررسی کنید.
        </CustomerStatus>
    );
}
